export const ROLES = {
  OPERATOR: 'operator',
  ADMIN: 'admin',
  SUPERVISOR: 'supervisor',
  PROFESSIONAL: 'professional'
};

export const PUBLIC_ROLES = [ROLES.OPERATOR, ROLES.ADMIN, ROLES.SUPERVISOR, ROLES.PROFESSIONAL];
